import {useState} from 'react';
import {Link, useHistory} from 'react-router-dom';
import axios from 'axios';

const Register = () => {

    const [username, setUsername] = useState()
    const [password, setPassword] = useState();
    const [email, setEmail] = useState();

    const history = useHistory();

    const handleRegister = (e) => {
        e.preventDefault();
        axios.post('http://localhost:8000/registerUser', {username, email, password})
        .then(res => {
            history.push('/login')
        })
        .then(err => console.log(err))
    }
    
    return (
        <>
            <div className="home">
				<nav>
					<ul>
                        <li><a href="/">Movie Home</a></li>
                        
					</ul>
				</nav>
			</div>
            
            <div className="auth">
                <h2>Register Here!</h2>
                <br/>
                <form onSubmit={handleRegister}>
                    <label>Username:</label><br/>
                    <input type="text" name="username" 
                    placeholder="Enter Username"
                    autoComplete="off"
                    onChange={(e) => setUsername(e.target.value)}
                    /><br/>
                    <label>Email:</label><br/>
                    <input type="text" name="email" 
                    placeholder="Enter Email"
                    autoComplete="off"
                    onChange={(e) => setEmail(e.target.value)}
                    /><br/>
                    <label>Password:</label><br/>
                    <input type="password" name="password" 
                    placeholder="Enter Password"
                    autoComplete = "off"
                    onChange={(e) => setPassword(e.target.value)}
                    />
                    <br/><br/>
                    <button type="submit">Register</button><br/><br/>
                    <p>Already have an Account?</p>
                    <Link to="/login" id="link">Login</Link>
                    <br/><br/>
                </form>
            </div>
        </>
    )
}

export default Register;